import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

// The dirty-or-submitted error matcher is deliberately NOT provided here: at root it would flip
// touched→dirty error semantics for every legacy admin form. In-scope form components opt in
// via component-level provideErrorStateMatcher(DirtyOrSubmittedErrorStateMatcher).
export function provideSpartanHlm(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }]);
}
